import { buildServicePageStructuredData } from './servicePageSchema';

export const SERVICES_PAGE = {
  hero: {
    eyebrow: 'ИИ-решения для бизнеса',
    h1: 'Внедрение ИИ-решений',
    subtitle:
      'ИИ-агенты, корпоративная AI-based база данных (RAG) и on-prem разработка — в облаке или в контуре компании. Один подрядчик. SLA.',
  },
  tldr:
    'Антология внедряет в России: ИИ-агенты, корпоративную AI-based базу данных (RAG), on-prem AI. Интеграция с CRM, Service Desk и базой знаний. Облако и on-premise, работаем с юрлицами по договору.',
  intro: {
    title: 'Интеграция ИИ в бизнес-процессы',
    text:
      'Подбираем коробочные решения или разрабатываем под задачу — и подключаем к вашим системам: CRM, хранилищам, порталам и внутренним сервисам.',
    formats: [
      { title: 'Коробка', what: 'Готовый ИИ-продукт + настройка', when: 'Быстрый запуск типового сценария' },
      { title: 'Доработка', what: 'Коробка + кастомизация сценариев', when: 'Почти закрывает задачу' },
      { title: 'On-prem', what: 'ИИ в контуре компании', when: 'Жёсткие требования ИБ' },
    ],
    note: 'Облако и on-premise. Оплата в рублях, закрывающие документы для юрлиц и ИП.',
  },
  servicesSection: {
    title: 'ИИ-решения',
    subtitle: 'Агенты, AI-based база данных (RAG) и on-prem — в облаке или в контуре компании',
  },
  servicesAccent: true,
  services: [
    {
      id: 'ai-agents',
      icon: 'Bot',
      cardTitle: 'ИИ-агенты для бизнеса',
      h2: 'Что даёт корпоративный ИИ-агент?',
      lead:
        'ИИ-агент выполняет цепочку действий в корпоративных системах — не просто отвечает в чате, а работает по регламентам и правам доступа.',
      summary:
        'Автоматизация рутины: обращения, документы, данные в CRM, Service Desk и мессенджерах. Коробка или разработка под сценарий.',
      steps: [
        'Подбор или разработка агента под область: продажи, поддержка, HR, закупки',
        'Роли, права и интеграции с CRM, почтой, чатами, хранилищами',
        'Подключение к базе знаний и API',
        'Обучение и запуск с runbook и SLA',
      ],
      scenarios: [
        { name: 'AI-оператор 1-й линии', result: 'Ответы по регламентам без очереди' },
        { name: 'Ассистент продаж', result: 'Черновики КП, резюме встреч' },
        { name: 'Агент отчётов', result: 'Запросы к данным на естественном языке' },
      ],
      delivery: 'облако · частное облако · on-premise',
      timeline: 'от 3 рабочих дней (типовой) до нескольких месяцев (кастом). Оценка после аудита.',
      citation:
        'Антология внедряет корпоративных ИИ-агентов в России: интеграция с CRM и базой знаний, облако или on-premise, оплата в рублях, SLA.',
      cta: 'Обсудить ИИ-агента',
      image: '/images/corporate-ai-agent.png',
      imageAlt: 'Роботизированная рука автоматизирует работу с документами — корпоративный ИИ-агент',
    },
    {
      id: 'rag',
      icon: 'Search',
      cardTitle: 'Корпоративная AI-based база данных (RAG)',
      h2: 'Зачем бизнесу корпоративная AI-based база данных (RAG)?',
      lead:
        'AI-based база данных (RAG) ищет фрагменты во внутренних документах и системах, затем формирует ответ со ссылкой на источник — без выноса данных за периметр.',
      summary:
        'Поиск и ответы по регламентам, wiki, CRM и файловым хранилищам. Точные ответы в рамках политик ИБ.',
      steps: [
        'Аудит источников: хранилища, wiki, CRM, тикет-системы',
        'Архитектура индексации и разграничения доступа',
        'Коробочная AI-based база данных (RAG) или кастом под ИБ',
        'Интеграция с порталом, мессенджерами и ИИ-агентами',
      ],
      scenarios: [
        { name: 'База знаний с AI-поиском', result: 'Единая точка ответов' },
        { name: 'Онбординг', result: 'Регламенты без нагрузки на наставников' },
        { name: 'Слой для агентов', result: 'Ответы из проверенных данных' },
      ],
      delivery: 'облако · on-premise · гибрид',
      timeline: 'от 5 рабочих дней (типовая коробка) до 4–8 недель (сложный ландшафт).',
      citation:
        'Корпоративная AI-based база данных (RAG): индексация документов и CRM, ответы со ссылкой на источник, on-premise для жёстких требований ИБ.',
      cta: 'Запросить демо AI-based база данных (RAG)',
      image: '/images/corporate-rag.png',
      imageAlt: 'ИИ-агент с доступом к корпоративным документам Word, Excel, PDF и облачным хранилищам — корпоративная AI-based база данных (RAG)',
    },
    {
      id: 'ai-on-prem',
      icon: 'Cpu',
      cardTitle: 'On-prem ИИ-разработка',
      h2: 'Как развернуть ИИ в контуре компании?',
      lead:
        'Проектируем и внедряем ИИ в закрытом периметре: частные LLM, inference-стеки, air-gap — с учётом 152-ФЗ и политик ИБ.',
      summary:
        'Локальные модели, AI-based база данных (RAG) и агенты без передачи данных наружу. Пилот → промышленная эксплуатация.',
      steps: [
        'Аудит требований ИБ, объёма данных и нагрузки',
        'Выбор стека: LLM, векторная БД, оркестрация агентов',
        'Развёртывание в контуре клиента, интеграция с системами',
        'Тестирование, обучение, сопровождение по SLA',
      ],
      scenarios: [
        { name: 'Закрытая AI-based база данных (RAG)', result: 'Поиск по документам без облака' },
        { name: 'Локальные агенты', result: 'Автоматизация в air-gap' },
        { name: 'Гибрид', result: 'Чувствительные данные on-prem, остальное в облаке' },
      ],
      delivery: 'on-premise · частное облако · гибрид',
      timeline: 'от 2–4 недель (пилот) до 2–3 месяцев (промышленный контур).',
      citation:
        'Антология разрабатывает on-prem ИИ-решения в России: частные LLM, AI-based база данных (RAG) и агенты в контуре клиента, соответствие 152-ФЗ и корпоративным политикам ИБ.',
      cta: 'Обсудить on-prem ИИ',
      image: '/images/ai-on-prem.png',
      imageAlt: 'Серверная стойка on-premise с подключением к CRM и файловому хранилищу — развёртывание ИИ в контуре компании',
    },
  ],
  whyUs: {
    title: 'Почему Антологию выбирают для внедрения ИИ?',
    rows: [
      { title: 'Интеграция', text: 'Подключаем ИИ к CRM, Service Desk и базе знаний' },
      { title: 'Коробка или кастом', text: 'Старт с готового продукта, доработка по необходимости' },
      { title: 'On-premise', text: 'Развёртывание в контуре при требованиях ИБ' },
      { title: 'Оплата в рублях', text: 'Безнал, договор, акты для юрлиц и ИП' },
      { title: 'SLA', text: 'Сопровождение через ЦБР после запуска' },
      { title: 'С 2017 года', text: 'Проекты для среднего и крупного бизнеса в РФ' },
    ],
  },
  process: {
    title: 'Как проходит внедрение ИИ?',
    steps: [
      { title: 'Аудит', text: 'Задача, процессы, ИБ. Первая встреча бесплатно.' },
      { title: 'Проект', text: 'Архитектура, сроки, стоимость в КП.' },
      { title: 'Внедрение', text: 'Настройка, интеграция, тесты.' },
      { title: 'Запуск', text: 'Обучение, пилот, эксплуатация.' },
      { title: 'SLA', text: 'Поддержка и развитие сценариев.' },
    ],
  },
  ecosystem: {
    title: 'Как связаны ИИ-агенты, AI-based база данных (RAG) и корпоративные системы?',
    intro: 'ИИ работает на данных из вашего ИТ-ландшафта:',
    layers: [
      { layer: 'Корпоративные системы', role: 'CRM, хранилища, Service Desk — источники данных' },
      { layer: 'AI-based база данных (RAG)', role: 'Поиск по документам и регламентам' },
      { layer: 'ИИ-агент', role: 'Действия на основе данных и знаний' },
    ],
    example:
      'Сотрудник спрашивает агента о регламенте — AI-based база данных (RAG) находит документ, агент формирует ответ или создаёт задачу в Service Desk.',
  },
  relatedPage: {
    label: 'Внедрение корпоративных систем',
    href: '/enterprise-systems',
    text: 'Поставка и внедрение лицензируемого ПО: общее, ИБ, инфраструктура, САПР.',
  },
  faq: [
    {
      q: 'Чем ИИ-агент отличается от чат-бота?',
      a: 'Агент понимает контекст, обращается к корпоративным данным и выполняет действия в системах — создать задачу, обновить запись, сформировать документ.',
    },
    {
      q: 'Что такое корпоративная AI-based база данных (RAG)?',
      a: 'AI-based база данных (RAG) отвечает на основе фрагментов из ваших документов и систем, а не из общих знаний модели. Сотрудник видит источник ответа.',
    },
    {
      q: 'Можно ли развернуть ИИ on-premise?',
      a: 'Да. On-premise и частное облако — для 152-ФЗ, коммерческой тайны и политик ИБ. Архитектура зависит от объёма данных и платформы.',
    },
    {
      q: 'Сколько стоит внедрение ИИ?',
      a: 'Зависит от масштаба и формата: коробка, доработка или проект под ключ. После аудита — КП с этапами. Сопровождение — на странице ЦБР.',
      linkCbr: true,
    },
    {
      q: 'Внедряете или только поставляете лицензии?',
      a: 'Полный цикл: внедрение, обучение и техподдержка по SLA через Центр быстрого реагирования.',
    },
  ],
};

export function buildServicesStructuredData() {
  return buildServicePageStructuredData({
    page: SERVICES_PAGE,
    path: '/services',
    pageName: 'Внедрение ИИ-решений',
    orgDescription:
      'VAR и системный интегратор B2B: внедрение ИИ-агентов, корпоративная AI-based база данных (RAG) и on-prem AI в России',
  });
}
